import { useCtx } from '@reatom/npm-react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import type { ContextGet } from './context.ts';
import { createGetContext } from './context.ts';

type Callback<Args extends Array<unknown>, Result = unknown> = (ctx: ContextGet) => (...args: Args) => Result;
export function useCallbackRef$<Args extends Array<unknown>, Result = unknown>(
  callback$: Callback<Args, Result>,
): (...args: Args) => Result;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useCallbackRef$<T extends (...args: Array<any>) => any>(callback: Callback<Parameters<T>>): T;
export function useCallbackRef$<Args extends Array<unknown>, Result>(callback$: Callback<Args, Result>): (...args: Args) => Result {
  const ctx = useCtx();

  return useCallbackRef(callback$(createGetContext(ctx)));
}
